
import moment from 'moment';
import { Component, Vue, Mixins } from 'vue-property-decorator';
import { getExpense } from '@/api/coinManaging';
import { PageQuery } from '@/mixins/page_query';
import LogUtils from 'panda-log';
import { toast } from '../../../utils/common';
import { eConfigId, eBillingMethod, eClientType } from '../../../interface/eCommand';
import { iConsumeRecord, eOrderDuration } from '../../../interface/consume-record';
import DetailDialog from './consume-record-dialog.vue';
import { Areas } from '../../../utils/area';
@Component({
  filters: {
    local_time_str(val: number) {
      return moment(val * 1000).format('YYYY-MM-DD HH:mm:ss');
    },
    hour_miniute(mint: number) {
      let hour: number;
      let miniute: number;
      miniute = mint % 60;

      if (mint > 60) {
        hour = Math.floor(mint / 60);
        if (miniute === 0) {
          return `${hour}小时`;
        } else {
          return `${hour}小时${miniute}分`;
        }
      } else if (mint === 60) {
        return `${mint}分钟`;
      } else {
        return `${miniute}分钟`;
      }
    },
  },
  components: {
    DetailDialog,
  },
})
export default class RechargeRecord extends Vue {
  private start!: any;
  private end!: any;
  currentInfo: iConsumeRecord | null = null; //当前选择的订单内容
  detailDialogVisible: boolean = false; //详情弹窗是否显示
  areas: any[] = Areas;

  private loading = false;
  total: number = 0;
  private experience: eConfigId = eConfigId.EXPERIENCE;
  private cloudcion = eBillingMethod.CLOUDCION;
  private experienceTwo = eBillingMethod.EXPERIENCE;
  private cyclecard = eBillingMethod.CYCLECARD;
  private cloudUpdate = eBillingMethod.CLOUDUPDATE;
  eclentType = eClientType;
  private configArr = ['全部状态', '标配服', '高配服', '体验服', '尊享服'];
  private tableData: iConsumeRecord[] = [];

  private query = {
    order_no: '',
    store_name: '',
    store_id: '',
    nickname: '',
    uid: '',
    page: 1,
    page_size: 30,
  };
  searchList() {
    if (!this.query.store_id && !this.query.order_no && !this.query.store_name && !this.query.uid && !this.query.nickname) {
      this.$message('请输入查询条件');
      return;
    }
    this.query.page = 1;
    this.getList();
  }
  handleSizeChange(page_size: number) {
    this.query.page = 1;
    this.query.page_size = page_size;
    if (!this.query.store_id && !this.query.order_no && !this.query.store_name && !this.query.uid && !this.query.nickname) {
      this.$message('请输入查询条件');
      return;
    }
    this.getList();
  }
  handleCurrentChange(page: number) {
    this.query.page = page;
    if (!this.query.store_id && !this.query.order_no && !this.query.store_name && !this.query.uid && !this.query.nickname) {
      this.$message('请输入查询条件');
      return;
    }
    this.getList();
  }
  statusChange() {}
  async getList() {
    try {
      this.loading = true;
      const res = await getExpense(this.query);
      if (res && res.data.list) {
        this.tableData = res.data.list;
        this.total = res.data.total;
      }
    } catch (error) {
      LogUtils.debug(error);
    } finally {
      this.loading = false;
    }
  }
  showDetail(info: iConsumeRecord) {
    this.detailDialogVisible = true;
    this.currentInfo = info;
  }

  mounted() {}
}
